import { CheckoutState } from '../../state';
import { isExpressPayPalFFEnabled } from '../splitio';
import { areAsyncExpressPaypalEligibleRulesMet } from './areAsyncExpressPaypalEligibleRulesMet';
import { areSyncExpressPaypalEligibleRulesMet } from './areSyncExpressPaypalEligibleRulesMet';

export const isExpressPaypalEnabled = (state: CheckoutState) =>
    areSyncExpressPaypalEligibleRulesMet(state) &&
    areAsyncExpressPaypalEligibleRulesMet(state) &&
    isExpressPayPalFFEnabled(state);
